import { CaretRightIcon as PhosphorCaretRightIcon } from "@phosphor-icons/react/dist/ssr/CaretRight";

import { createAppIcon } from "@/components/createAppIcon";

export const ChevronRightIcon = /* @__PURE__ */ createAppIcon(PhosphorCaretRightIcon);
